import { defineComponent, PropType } from 'vue';
import imageFail from '@/component/message/pic/component/image-plus/img/image_fail.png';

enum ImageStatus {
  init = 'init',
  loading = 'loading',
  error = 'error',
  success = 'success'
}

type ImagePlusData = {
  status: ImageStatus,
  ImageStatus: typeof ImageStatus,
  images: Record<string, string>
};

const CDN_DOMAIN_LIST: Array<RegExp> = [
  /^https?:\/\/static.gameplus.qq.com/,
  /^https?:\/\/test-static.gameplus.qq.com/,
  /^https?:\/\/knock-test.gtimg.com/,
  /^https?:\/\/knock.gtimg.com/,
  /^https?:\/\/knock-user-1300342587/,
];

const IMAGE_SIZE_RANGE: Array<number> = [80, 160, 320, 480, 640, 720, 800, 1080, 1440];

export default defineComponent({
  props: {
    url: {
      type: String as PropType<string | undefined>,
      default: undefined,
    },
    width: {
      type: Number as PropType<number>,
      required: true,
    },
    height: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  data(): ImagePlusData {
    return {
      status: ImageStatus.init,
      ImageStatus,
      images: {
        imageFail,
      },
    };
  },
  computed: {
    canReduce(): boolean {
      if (this.url) {
        const { length } = CDN_DOMAIN_LIST;
        for (let i = 0; i < length; i++) {
          if (CDN_DOMAIN_LIST[i].test(this.url)) {
            return true;
          }
        }
      }
      return false;
    },
    requestSrc(): string {
      if (this.url) {
        if (this.canReduce) {
          // 按宽度裁剪
          return `${this.url}?imageView2/2/w/${this.getSize(this.width)}/ignore-error/1`;
        }
        return this.url;
      }
      return '';
    },
  },
  watch: {
    url: {
      handler: 'setImageProgress',
      immediate: true,
    },
  },
  methods: {
    getSize(size: number): number {
      const len = IMAGE_SIZE_RANGE.length;
      for (let i = 0; i < len; i++) {
        if (size <= IMAGE_SIZE_RANGE[i]) {
          return IMAGE_SIZE_RANGE[i];
        }
      }
      return IMAGE_SIZE_RANGE[len - 1];
    },
    setImageProgress() {
      if (this.url) {
        const oImage = new Image();
        oImage.src = this.requestSrc;
        oImage.onload = () => {
          this.status = ImageStatus.success;
        };
        oImage.onerror = () => {
          this.status = ImageStatus.error;
        };
      } else {
        this.status = ImageStatus.error;
      }
    },
  },
});
